import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgxOtpInputComponent,
  NgxOtpInputComponentOptions,
  NgxOtpStatus,
} from 'ngx-otp-input'; // ✅ This is the key
import { Router, ActivatedRoute } from '@angular/router';
import { interval, Subscription, take } from 'rxjs';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { AuthService } from '../../auth.service';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-otp-verify',
  standalone: true,
  imports: [CommonModule, NgxOtpInputComponent], // ✅ this ensures it's available
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss'],
})
export class OtpVerifyComponent implements OnInit, OnDestroy {
  @Input() phoneNumber: string = '';
  @Input() isInDialog = false;
  @Output() resendOtpEvent = new EventEmitter<boolean>();
  @Output() loggedIn = new EventEmitter<boolean>();

  otpValue: string = '';
  errorMessage = '';
  otpSent = false;
  resendDisabled = true;
  resendTimer = 30;
  timerSubscription?: Subscription;
  status = NgxOtpStatus;
  @Output() verifyResponse = new EventEmitter<any>();

  otpOptions: NgxOtpInputComponentOptions = {
    autoFocus: true,
    otpLength: 6,
    showBlinkingCursor: true,
  };

  constructor(
    private router: Router,
    private _route: Router,
    private _activatedRoute: ActivatedRoute,
    private _globalUtilityService: GlobalUtilityService,
    private _authService: AuthService,
    private _sharedService: SharedService
  ) {}

  @ViewChild('otpInput') otpInput!: NgxOtpInputComponent;

  ngOnInit(): void {
    this.startResendTimer();
  }

  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }

  otpCompleted(otp: string): void {
    if (otp.length === 6) {
      this.otpValue = otp;
      this.verifyOtp();
    }
  }

  verifyOtp(): void {
    this._globalUtilityService.showLoader();
    this._authService.loginWithOtp(this.otpValue, this.phoneNumber).subscribe({
      next: (res: APIResponse) => {
        if (res.success) {
          this.verifyResponse.emit(res.data);
          this.loggedIn.emit(true);
        } else {
          this.invalidOtp();
        }
      },
      error: () => {
        this.invalidOtp();
      },
    });
  }

  resetForm() {
    this.otpInput.reset();
  }

  invalidOtp(): void {
    this._globalUtilityService.hideLoader();
    this.errorMessage = 'Invalid OTP. Please try again.';
    this.otpValue = '';
    this.resetForm();
  }

  resendOtp(): void {
    if (this.resendDisabled) return;

    this.otpValue = '';
    this.errorMessage = '';
    this.resendOtpEvent.emit(true);

    this._authService.sendOtp(this.phoneNumber).subscribe({
      next: (res: APIResponse) => {
        this._globalUtilityService.showToast('success', res.message);
        this.resendDisabled = true;
        this.startResendTimer();
        this.otpSent = true;
      },
      error: (error: any) => {
        this._globalUtilityService.showToast('Error', error.message);
      },
    });
  }

  startResendTimer(): void {
    this.resendDisabled = true;
    this.resendTimer = 30;

    this.timerSubscription?.unsubscribe();
    this.timerSubscription = interval(1000)
      .pipe(take(31))
      .subscribe(() => {
        this.resendTimer--;
        if (this.resendTimer <= 0) {
          this.resendDisabled = false;
          this.timerSubscription?.unsubscribe();
        }
      });
  }
}
